import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionWrapper from '../../../containers/SectionWrapper/SectionWrapper.container';
import { path } from '../../../routes/paths';
import HeaderCaption from '../header-caption/HeaderCaption.component';
import Logo from '../logo/Logo';
import { Container } from './Footer.styles';
import FooterColumn from './FooterColumn';

const Footer = () => {
  const { t } = useTranslation();

  const company = [
    {
      id: 0,
      label: t('footer-about'),
      path: 'about'
    },
    {
      id: 1,
      label: t('footer-careers'),
      path: 'careers'
    },
    {
      id: 2,
      label: t('footer-contact'),
      path: 'contact'
    },
    {
      id: 3,
      label: t('footer-privacy-policy'),
      path: 'privacy-policy'
    },
    {
      id: 4,
      label: t('footer-terms-of-service'),
      path: 'terms-of-service',
      to: path.TERMS_OF_SERVICE
    }
  ];

  const products = [
    {
      id: 0,
      label: t('footer-marketplace'),
      path: 'marketplace'
    },
    {
      id: 1,
      label: t('footer-houses'),
      path: 'terre-houses'
    },
    {
      id: 2,
      label: t('footer-logistics'),
      path: 'terre-logistics'
    }
  ];

  const resources = [
    {
      id: 0,
      label: t('footer-blog'),
      path: 'terre-blog'
    }
  ];

  return (
    <SectionWrapper height={100} bgColor="#531703">
      <Container>
        <div>
          <Logo width={102} height={35} />
          <HeaderCaption
            heading={t('extend-reach')}
            caption={t('extend-reach-text')}
            textAlign="left"
            headingSize="10px"
            captionSize="12px"
            captionLength="72%"
            headingMargin="22px 0px 0px"
            alignItems='flex-start'
            captionMargin='20px 0px'
          />
        </div>
        <FooterColumn heading={t('footer-company')} values={company} />
        <FooterColumn heading={t('footer-products')} values={products} comingSoon />
        <FooterColumn heading={t('footer-resources')} values={resources} />
      </Container>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderTop: '1px solid rgba(188, 176, 173, 1)',
          color: '#fff',
          fontSize: '12px'
        }}
      >
        <p style={{ marginTop: '20px' }}>
          <span>Copyright © 2022 Terre54</span>
        </p>
      </div>
    </SectionWrapper>
  );
};

export default Footer;
